import { render, staticRenderFns } from "./ManageSubmissionUsers.vue?vue&type=template&id=3bdf532d"
import script from "./ManageSubmissionUsers.vue?vue&type=script&lang=js"
export * from "./ManageSubmissionUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports